import React from "react";
import { CustomRoutes } from "react-admin";
import { Route } from "react-router-dom";
import { ActeurShow } from "./acteurs";
import { AgendaShow } from "./agenda/AgendaShow";
import { AlertList } from "./alerts";
import { DocumentShow } from "./documents";
import { DossierShow } from "./dossiers";
import { OrganeShow } from "./organes";
import { QuestionShow } from "./questions";
import { ReunionShow } from "./reunions";
import { ScrutinShow } from "./scrutins";
import { Search } from "./search";

export const routes = [
	<CustomRoutes key={1}>
		<Route
			path="/parliament/amendements/:id"
			element={<Search dataset={"amendements"} />}
		/>
		<Route path="/parliament/:dataset?" element={<Search />} />
		<Route path="/parliament/alertes" element={<AlertList />} />
		<Route
			path="/parliament/acteurs/:id/:dataset?/:amendementId?"
			element={<ActeurShow />}
		/>

		<Route path="/parliament/questions/:id" element={<QuestionShow />} />
		<Route path="/parliament/organes/:id" element={<OrganeShow />} />
		<Route
			path="/parliament/organes/:id/amendements/:amendementId"
			element={<OrganeShow />}
		/>
		<Route path="/parliament/documents/:id" element={<DocumentShow />} />
		<Route path="/parliament/dossiers/:id" element={<DossierShow />} />
		<Route path="/parliament/scrutins/:id" element={<ScrutinShow />} />
		<Route
			path="/parliament/reunions/:id/:interventionId?"
			element={<ReunionShow />}
		/>
		<Route path="/parliament/agenda" element={<AgendaShow />} />
	</CustomRoutes>,
];
